import { Stack } from '@mantine/core';
import { Button, Text, TextInput } from '@repo/foundations';
import { ReactNode, useState } from 'react';

interface IdentityTokenModalProps {
	description: ReactNode;
	onConfirm: (token: string) => void;
	onCancel: () => void;
}

export function IdentityTokenModal({
	description,
	onConfirm,
	onCancel,
}: IdentityTokenModalProps) {
	const [token, setToken] = useState('');
	const [error, setError] = useState<string | null>(null);

	const handleConfirm = () => {
		const trimmedToken = token.trim();
		if (!trimmedToken) {
			setError('Identity token is required.');
			return;
		}
		onConfirm(trimmedToken);
	};

	return (
		<Stack spacing="md">
			{description}
			{error && (
				<Text size="sm" color="text/critical/default">
					{error}
				</Text>
			)}
			<TextInput
				value={token}
				onChange={(e) => {
					setToken(e.target.value);
					setError(null);
				}}
				placeholder="Enter identity token"
				autoFocus
			/>
			<Stack spacing="xs">
				<Button variant="primary" onClick={handleConfirm}>
					Confirm
				</Button>
				<Button variant="tertiary" onClick={onCancel}>
					Cancel
				</Button>
			</Stack>
		</Stack>
	);
}
